import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import { useNavigate } from "react-router-dom";
import {
  baseUrl,
  currentUserRole,
  loggedUser,
} from "../../../Utility/constants";
import SchoolDetailsList from "./SchoolDetailsList";
import SchoolDetailsModal from "./SchoolDetailsModal";
import EditSchoolDetailsModal from "./EditSchoolDetailsModal";
import SchoolContactAffiliationDetailsModal from "./SchoolContactAffiliationDetailsModal";

const SchoolDetailsPage = () => {
  const navigate = useNavigate();
  const [schoolData, setSchoolData] = useState([]);
  const [schoolDetails, setSchoolDetails] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAffilicationModal, setShowAffilicationModal] = useState(false);
  const [formData, setFormData] = useState({
    schoolId: 0,
    organizationName: "",
    establishmentYear: "",
    schoolOrCollegeName: "",
    isNightSchoolOrCollege: false,
    location: "", // for location dropdown
    udiseNo: "",
    ssC10thIndexNo: "",
    hsC12thIndexNo: "",
    attachTypes: [],
    grantTypes: [], // multiple selection
    streams: [], // multiple selection
    schoolType: "",
    schoolOrCollegeTiming: "", // for school timing dropdown
    schoolRegistrationNumber: "",
    schoolRegistrationDate: "",
    collegeRegistrationNumber: "",
    collegeRegistrationDate: "",
    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID"),
    Logo: null,
    SessionID: 0,
    SchoolMedium: "",
  });

  const [affiliationFormData, setAffiliationFormData] = useState({
    schoolId: "",
    it: false,
    bifocal: false,
    minority: false,
    email: "",
    schoolOrCollegeContactNo: "", // Added field
    websiteName: "", // Added field
    schoolWebsiteName: "",
    principalName: "", // Added field
    principalContactNo: "", // Added field
    address: "", // Added field
    country: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    pincode: "", // Added field
    minorityType: "NA",
    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID"),
  });

  useEffect(() => {
        fetchSchools();
  }, []);

  const fetchSchools = async () => {
    try {
      const url =
      localStorage.getItem("Role") === "SUPERADMIN"
          ? `${baseUrl}/api/SchoolGeneralInfo`
          : `${baseUrl}/api/SchoolGeneralInfo/SchoolGeneralInfoByAdmin?AdminId=${localStorage.getItem(
              "userID"
            )}`;
      const response = await axios.get(url);
      setSchoolData(response.data);
    } catch (error) {
      toast.error("Failed to fetch school data");
    }
  };

  const onAddNewSchool = () => {
    navigate("/add-school");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this school?")) {
      try {
        await axios.delete(`${baseUrl}/api/SchoolGeneralInfo/${id}`);
        toast.success("School deleted successfully");
        fetchSchools();
        setSchoolData(schoolData.filter((school) => school.schoolId !== id));
      } catch (error) {
        toast.error("Failed to delete school");
      }
    }
  };

  const handleView = async (schoolId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
      );
      setSchoolDetails(response.data);
      setShowDetailsModal(true);
    } catch (error) {
      toast.error("Failed to fetch school details");
    }
  };

  const handleEdit = async (schoolId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
      );
      setFormData(response.data);
      setShowEditModal(true);
    } catch (error) {
      toast.error("Failed to fetch school details");
    }
  };

  const handleEditSubmit = async () => {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data", // Ensure Content-Type is set
      },
    };
    try {
      await axios.post(
        `${baseUrl}/api/SchoolGeneralInfo`,
        formData, config
      );
      toast.success("School updated successfully");
      fetchSchools();
      setShowEditModal(false);
    } catch (error) {
      toast.error("Failed to update school");
    }
  };

  const handleAffiliation = async (schoolId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/ContactAffiliationInfo/GetContactAffiliationInfoBySchoolId?schoolId=${schoolId}`
      );
      setAffiliationFormData(response.data);
      setShowAffilicationModal(true);
    } catch (error) {
      if(error.response && error.response.status && error.response.status === 404)
      {
        setAffiliationFormData((prevData) => ({
          ...prevData,
          schoolId: schoolId 
        }));
        setShowAffilicationModal(true);
      }
      else{
      toast.error("Failed to fetch school details");
      }
    }
  };

  const handleAffiliationSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${baseUrl}/api/ContactAffiliationInfo`,
        affiliationFormData
      );
      // Check if the response is successful (status code 2xx)
      if (response.status >= 200 && response.status < 300) {
        toast.success("Record updated successfully!"); // Show success toast
        setShowAffilicationModal(false); // Close modal
        fetchSchools();
      } else {
        toast.error("Failed to update record."); // Show error toast if status is outside 2xx
      }
    } catch (error) {
      toast.error("Failed to update record.");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <SchoolDetailsList
          data={schoolData}
          onAddNewSchool={onAddNewSchool}
          handleDelete={handleDelete}
          handleView={handleView}
          handleEdit={handleEdit}
          handleAffiliation={handleAffiliation}
        />

        {showDetailsModal && (
          <SchoolDetailsModal
            show={showDetailsModal}
            handleDetailsClose={() => setShowDetailsModal(false)}
            schoolData={schoolDetails}
          />
        )}

        {showEditModal && (
          <EditSchoolDetailsModal
            show={showEditModal}
            handleEditModalClose={() => setShowEditModal(false)}
            handleSubmit={handleEditSubmit}
            formData={formData}
            setFormData={setFormData}
          />
        )}

        {showAffilicationModal && (
          <SchoolContactAffiliationDetailsModal
            show={showAffilicationModal}
            handleAffilicationModalClose={() => setShowAffilicationModal(false)}
            handleSubmit={handleAffiliationSubmit}
            affiliationFormData={affiliationFormData}
            setAffiliationFormData={setAffiliationFormData}
          />
        )}
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default SchoolDetailsPage;
